import { ReactComponent as MyLocationIcon } from "../../../assets/icons/regular/my_location.svg";
import { useMyLocation } from "./MyLocation.hooks";
import { Button, Container } from "./MyLocation.styles";

export const MyLocation = () => {
  const { flyToMyLocation, hasPermission, show } = useMyLocation();

  return (
    <Container>
      <Button onClick={flyToMyLocation} hasPermission={hasPermission} className="my-location-container">
        <MyLocationIcon />
      </Button>
      {(!hasPermission && show) &&
        <span>Enable your localization to start searching for Medical Providers in your area.</span>
      }
    </Container>
  )
}
